import { useOutletContext as useOutletContextReactRouter } from 'react-router';

import type { AdditionalBreadcrumbItem } from '@/components/Layout';

export interface ContextType {
  addBreadcrumb?: (item: AdditionalBreadcrumbItem) => void;
  additionalBreadcrumbs: AdditionalBreadcrumbItem[];
  closingDate?: null | string;
  companyName?: string;
  ddStage?: null | string;
  icVoteTimestamp?: null | string;
  id: string;
  loading: boolean;
  opportunityName?: null | string;
  projectName?: null | string;
  targetEntityId?: null | string;
}

const useOutletContext = () => {
  return useOutletContextReactRouter<ContextType>();
};

export default useOutletContext;
